import { isPortableTextSpan } from "@sanity/types";
import { getFocusChild } from "./selector.is-overlapping-selection.js";
const getFocusInlineObject = (snapshot) => {
  const focusChild = getFocusChild(snapshot);
  return focusChild && !isPortableTextSpan(focusChild.node) ? {
    node: focusChild.node,
    path: focusChild.path
  } : void 0;
};
export {
  getFocusInlineObject
};
//# sourceMappingURL=selector.get-focus-inline-object.js.map
